import { FormEvent, useEffect, useState } from "react";
import TopNav from "../components/TopNav";
import { Link, useSearchParams } from "react-router-dom";
import {
  List,
  Avatar,
  ListItemText,
  ListItemAvatar,
  FormControl,
  InputLabel,
  OutlinedInput,
  IconButton,
  Button,
  ListItemButton,
  Menu,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import { Add, Search, FilterList, AddCircle } from "@mui/icons-material";
import utilStyle from "./Utils.module.css";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  APICustomer,
  APICustomerFilter,
  getAllCustomers,
} from "../api/customers";
import SplitPageView from "../components/SplitPageView";
import CustomerDetailsPage from "./CustomerDetailsPage";

function CustomerListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [customersData, setCustomerData] = useState<APICustomer[]>([]);
  const [search, setSearch] = useState("");
  useEffect(() => {
    getAllCustomers().then((v) =>
      setCustomerData(
        [...v].sort((a, b) =>
          `${a.lastName} ${a.firstName}`.localeCompare(
            `${b.lastName} ${b.firstName}`
          )
        )
      )
    );
  }, [id]);

  const terms = search.toLowerCase().split(/\s+/).filter(Boolean);
  const visible = customersData.filter((c) => {
    const haystack = [
      c.firstName,
      c.lastName,
      c.phone,
      c.email,
      c.addressLine1,
      c.city,
    ]
      .join(" ")
      .toLowerCase();
    return terms.every((t) => haystack.includes(t));
  });

  return (
    <SplitPageView
      selected={
        !!searchParams.get("id") ||
        !!searchParams.get("cid") ||
        !!searchParams.get("new")
      }
      pageTitle="Customers"
      search={search}
      onSearchChange={setSearch}
      contentList={
        <List style={{ padding: 0 }}>
          <ListItem>
            <Button
              component={Link}
              to="/customers?new=1"
              variant="contained"
              startIcon={<Add />}
              fullWidth
            >
              New Customer
            </Button>
          </ListItem>
          {visible.map((customer) => (
            <ListItemButton
              component={Link}
              to={`/customers?id=${customer.id}`}
              key={customer.id}
              selected={id === customer.id}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: "primary.light" }}>
                  {customer.firstName && customer.firstName[0].toUpperCase()}
                  {customer.lastName && customer.lastName[0].toUpperCase()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  `${customer.firstName} ${customer.lastName}`.trim() ||
                  "Unnamed customer"
                }
                secondary={[customer.addressLine1, customer.city]
                  .filter(Boolean)
                  .join(", ")}
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItemButton>
          ))}
          {visible.length === 0 && (
            <ListItem>
              <ListItemText
                secondary={search ? "No customers match." : "No customers yet."}
              />
            </ListItem>
          )}
        </List>
      }
      mainContent={<CustomerDetailsPage id={id || undefined} />}
    />
  );
}

export default CustomerListPage;
